import React from 'react'
import { COLORS } from '@btime/constants'
import SideMenuPageTemplate from '../../../components/templates/v2/SideMenuTemplate'
import ServiceOrderNotificationAlert from '../../serviceOrders/_common/ServiceOrderNotificationAlert'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import { PermissionChecker } from '../../session'
import ConfigsLoader from '../../../containers/configs/_load/ConfigsLoader'
import FilterWrapper from '../filters/FilterWrapper'
import ProcessesListByIdLoader from '../_load/ProcessesListById'
import PageHeader from './PageHeader'
import AddNewButton from './AddNewButton'
import { useLocalStorageWatcher } from '../../../utils/helpers/localStorage'

const ProcessesViewModeWrapper = ({ id, children }) => {
  useLocalStorageWatcher('LAST_PROCESS_ID', id)

  return (
    <SideMenuPageTemplate bgColor={COLORS.white}>
      <ServiceOrderNotificationAlert>
        <Separator weight={6} flex={1}>
          <PermissionChecker permission="listServiceOrder">
            <ConfigsLoader>
              <FilterWrapper>
                <ProcessesListByIdLoader id={id}>
                  <PageHeader />
                  {children}
                </ProcessesListByIdLoader>
                <AddNewButton />
              </FilterWrapper>
            </ConfigsLoader>
          </PermissionChecker>
        </Separator>
      </ServiceOrderNotificationAlert>
    </SideMenuPageTemplate>
  )
}

export default ProcessesViewModeWrapper
